import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, UrlModule } from '@spartacus/core';
import { MessageModule } from '@spartacus/organization/administration/components';
import {
  IconModule,
  KeyboardFocusModule,
  PaginationModule,
  PopoverModule,
  SplitViewModule,
  TableModule,
} from '@spartacus/storefront';
import { UigUserListComponent } from './uig-user-list.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SplitViewModule,
    TableModule,
    IconModule,
    UrlModule,
    I18nModule,
    PaginationModule,
    NgSelectModule,
    FormsModule,
    MessageModule,
    KeyboardFocusModule,
    PopoverModule
  ],
  declarations: [UigUserListComponent],
  exports: [UigUserListComponent]
})
export class UigUserListModule { }
